import * as React from "react"

const MOBILE_BREAKPOINT = 768
const DESKTOP_BREAKPOINT = 1024

type ActiveBreakpoint = "mobile" | "tablet" | "desktop"

export function useBreakpoint(): {
  isMobile: boolean
  isTablet: boolean
  isDesktop: boolean
  active: ActiveBreakpoint
} {
  const [active, setActive] = React.useState<ActiveBreakpoint>("desktop")

  React.useEffect(() => {
    const mobileMql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const tabletMql = window.matchMedia(
      `(min-width: ${MOBILE_BREAKPOINT}px) and (max-width: ${DESKTOP_BREAKPOINT - 1}px)`,
    )

    const onChange = () => {
      if (mobileMql.matches) {
        setActive("mobile")
        return
      }
      if (tabletMql.matches) {
        setActive("tablet")
        return
      }
      setActive("desktop")
    }

    mobileMql.addEventListener("change", onChange)
    tabletMql.addEventListener("change", onChange)
    onChange()

    return () => {
      mobileMql.removeEventListener("change", onChange)
      tabletMql.removeEventListener("change", onChange)
    }
  }, [])

  return {
    isMobile: active === "mobile",
    isTablet: active === "tablet",
    isDesktop: active === "desktop",
    active,
  }
}

export function useIsMobile() {
  return useBreakpoint().isMobile
}
